import { Link } from 'react-router-dom'

export function HardwareHomeView() {
  return (
    <div className="page page--hardware-home">
      <header className="hardware-home-header">
        <h1 className="hardware-home-title">🔧 Hardware Store</h1>
        <Link to="/" className="hardware-home-back" aria-label="Back to store selection">←</Link>
      </header>

      <section className="hardware-home-section" aria-labelledby="hardware-choose-heading">
        <h2 id="hardware-choose-heading" className="hardware-home-section-title">What do you want to do?</h2>
        <div className="hardware-home-cards">
          <Link
            to="/hardware/build"
            className="hardware-home-card hardware-home-card--build"
            aria-label="Build something step by step"
          >
            <span className="hardware-home-card-emoji" aria-hidden>🪚</span>
            <span className="hardware-home-card-name">Build</span>
            <span className="hardware-home-card-desc">Pick a project, follow the steps, and build something together!</span>
          </Link>
          <Link
            to="/hardware/repair"
            className="hardware-home-card hardware-home-card--repair"
            aria-label="Fix something step by step"
          >
            <span className="hardware-home-card-emoji" aria-hidden>🔧</span>
            <span className="hardware-home-card-name">Repair</span>
            <span className="hardware-home-card-desc">Tighten a screw, fix a wobbly chair, or patch a hole.</span>
          </Link>
          <Link
            to="/hardware/paint"
            className="hardware-home-card hardware-home-card--paint"
            aria-label="Paint something"
          >
            <span className="hardware-home-card-emoji" aria-hidden>🎨</span>
            <span className="hardware-home-card-name">Paint</span>
            <span className="hardware-home-card-desc">Pick something to paint and choose your favorite color!</span>
          </Link>
          <Link
            to="/hardware/measure"
            className="hardware-home-card hardware-home-card--measure"
            aria-label="Learn to measure"
          >
            <span className="hardware-home-card-emoji" aria-hidden>📏</span>
            <span className="hardware-home-card-name">Measure</span>
            <span className="hardware-home-card-desc">How long is it? Practice measuring with blocks.</span>
          </Link>
          <Link
            to="/hardware/shop"
            className="hardware-home-card hardware-home-card--shop"
            aria-label="Shop for hardware and tools"
          >
            <span className="hardware-home-card-emoji" aria-hidden>🛒</span>
            <span className="hardware-home-card-name">Shop</span>
            <span className="hardware-home-card-desc">Browse tools, nails, paint & more for your cart.</span>
          </Link>
        </div>
      </section>

      <footer className="hardware-home-footer">
        <Link to="/parent" className="home-parent-link">Parent</Link>
      </footer>
    </div>
  )
}
